import React from 'react';
import 'react-table-v6/react-table.css';
import Sidebar from '../commonAdmin/Sidebar';
import Header from '../commonAdmin/Header';
import {
  Card,
  Col,
  Container,
  Form,
  FormControl,
  Image,
  Modal,
  Nav,
  Row,
  Tab,
  Table,
} from 'react-bootstrap';
import Footer from '../commonAdmin/Footer';
import Loader from '../../common/Loader';

// import PromoList from './promotion/PromoList';
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useState } from 'react';
import delivaApiService from '../../../common/services/apiService';
import { useEffect } from 'react';

import { ReactComponent as Copy } from './../../../assets/images/icons/copy.svg';
import { ReactComponent as Edit } from './../../../assets/images/icons/edit.svg';
import { ReactComponent as Alert } from './../../../assets/images/icons/alert.svg';
import notificationBell from './../../../assets/images/notificationBell.svg';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../common/helpers/Utils';

const NotificationSetting = ({ refferalId, type, onClose, onHide }) => {
  // hooks
  const history = useHistory();
  // state management
  const [loading, setLoading] = useState(false);
  const [allReferral, setAllReferral] = useState();
  const [allPromo, setAllPromo] = useState();
  const [allActiveNotification, setAllActiveNotification] = useState('');
  const [showNotification, setShowNotification] = useState(true); // Show notification modal if 'show' prop is true
  const [totalRecords, setTotalRecords] = useState('');
  const [searchText, setSearchText] = useState('');
  const [selectedNotification, setSelectedNotification] = useState([]);
  const [tempSelectedNotification, setTempSelectedNotification] = useState([]);
  const [selectedReferralID, setSelectedReferralID] = useState(
    refferalId || ''
  );
  const [isNotificationEnabled, setIsNotificationEnabled] = useState();
  const [error, setError] = useState(null);
  const [allNotificationTypes, setAllNotificationTypes] = useState([]);
  const [activeTab, setActiveTab] = useState(type || 'referral'); // Default to 'referral' if no type is provided

  console.log(refferalId, 'refferalId58....');

  // 1. Fetches all possible notification options
  const handleAllNotificationOptions = async () => {
    setLoading(true);
    setError(null);
    try {
      let response = await delivaApiService('getAllNotificationType');
      console.log('getAllNotificationType response:', response);
      if (response?.status === 200) {
        setAllNotificationTypes(response?.data?.resourceData || []);
        console.log(
          'getAllNotificationType data:',
          response?.data?.resourceData
        );
      } else {
        setError(
          response.responseMessage || 'Failed to load all notification options.'
        );
      }
    } catch (err) {
      console.error('Failed to fetch all notification types:', err);
      setError(
        'Error fetching all notification types: ' +
          (err.message || 'Unknown error')
      );
    } finally {
      setLoading(false);
    }
  };

  // 3. Gets currently active notifications for a given referral ID
  const getActivateNotifications = async (id) => {
    if (!id) {
      setAllActiveNotification([]);
      setTempSelectedNotification([]);
      setSelectedNotification([]); // Clear selected checkboxes too
      return;
    }
    setLoading(true);
    setError(null);
    try {
      let payload = { referralId: id };
      console.log(payload);
      let response = await delivaApiService(
        'getActivateNotifications',
        payload
      );
      if (response?.status === 200) {
        const activeData = response?.data?.resourceData || [];
        setAllActiveNotification(activeData);
        setTempSelectedNotification(activeData.notifications || []);
        setSelectedNotification(activeData.notifications || []);
        let selectedReferral = allReferral.find(
          (item) => item.referralId === id
        );
        setIsNotificationEnabled(selectedReferral?.notificationEnable);
        console.log('Line 299 isNotificationEnabled:', isNotificationEnabled);
      } else {
        setError(
          response.responseMessage || 'Failed to load active notifications.'
        );
      }
    } catch (err) {
      console.error('Failed to get activated notifications:', err);
      setError(
        'Error fetching active notifications: ' +
          (err.message || 'Unknown error')
      );
    } finally {
      setLoading(false);
    }
  };

  // 2. Activates selected notifications
  const handleActivateNotification = async () => {
    if (selectedNotification.length === 0) {
      setError('Please select at least one notification option to activate.');
      return;
    }
    setLoading(true);
    try {
      let payload = {
        referralId: refferalId,
        type: activeTab,
        active: true,
        notifications: selectedNotification,
        notificationEnable: true,
      };

      console.log(payload, 'payload');

      const response = await delivaApiService('notificationActivate', payload);
      if (response?.status === 200) {
        // showSuccessToast('Notification Setting activated.');
        showSuccessToast(
          tempSelectedNotification?.length > 0
            ? 'Notification Setting Updated'
            : 'Notification Setting Activated'
        );
        onHide();
        // Re-fetch active notifications for the refferalId
        getActivateNotifications(refferalId);
        setSelectedNotification([]);
        setTempSelectedNotification([]);
      } else if (response?.status === 404) {
        showErrorToast('Notification Setting already activated.');
        // onHide();
      } else {
        setError(
          response.responseMessage || 'Failed to activate notifications.'
        );
      }
    } catch (err) {
      console.error('Failed to activate notifications:', err);
      setError(
        'Error activating notifications: ' + (err.message || 'Unknown error')
      );
    } finally {
      setLoading(false);
    }
  };

  // Handles changes to individual checkboxes
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedNotification((prevSelected) => {
      if (checked) {
        return [...prevSelected, value];
      } else {
        return prevSelected.filter((id) => id !== value);
      }
    });
  };

  // Runs once on component mount to fetch all available notification types
  useEffect(() => {
    handleAllNotificationOptions();
  }, []);

  useEffect(() => {
    if (refferalId) {
      getActivateNotifications(refferalId);
    } else {
      setAllActiveNotification([]);
      setSelectedNotification([]);
      setTempSelectedNotification([]);
    }
  }, [refferalId]);

  useEffect(() => {
    handleAllNotificationOptions();
    getActivateNotifications(refferalId);
  }, [refferalId]);

  return (
    <Modal show={true} centered>
      <Modal.Body>
        <div className="modal-content-wrap text-center">
          <Image src={notificationBell} className="img-fluid user-block-img" />
          <h4 className="tertiary-color mt-3">Notification Setting</h4>
          <p className="color-grey mb-4">
            Please select notification options to notify user
          </p>
          <Card className="mb-5 mt-2">
            <Card.Body className="p-4">
              <Loader showLoader={loading} />
              <div className="notification-wrapper">
                {allNotificationTypes.length > 0 ? (
                  activeTab === 'referral' ? (
                    allNotificationTypes
                      .slice(0, 2)
                      .map((notification, index) => (
                        <div className="checkboxContainer" key={index}>
                          <input
                            type="checkbox"
                            id={`notify${index + 1}`}
                            name={notification.value}
                            value={notification.value}
                            disabled={tempSelectedNotification.includes(
                              notification.value
                            )}
                            checked={selectedNotification.includes(
                              notification.value
                            )}
                            onChange={handleCheckboxChange}
                          />
                          <label htmlFor={`notify${index + 1}`}>
                            {notification.label}
                          </label>
                        </div>
                      ))
                  ) : (
                    allNotificationTypes.map((notification, index) => (
                      <div className="checkboxContainer" key={index}>
                        <input
                          type="checkbox"
                          id={`notify${index + 1}`}
                          name={notification.value}
                          value={notification.value}
                          checked={
                            selectedNotification.includes(notification.value) &&
                            isNotificationEnabled
                          }
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor={`notify${index + 1}`}>
                          {notification.label}
                        </label>
                      </div>
                    ))
                  )
                ) : (
                  <p>No notification options available.</p>
                )}
              </div>
            </Card.Body>
          </Card>

          <button
            className="cancel-btn mr-3"
            onClick={() => {
              onClose();
              setSelectedNotification([]);
              setTempSelectedNotification([]);
            }}
          >
            Cancel
          </button>
          {/* (selectedNotification.length === tempSelectedNotification.length) || (activeTab === "referral" && tempSelectedNotification.length === 2) || */}
          {((activeTab === 'referral' &&
            tempSelectedNotification.length !== 2) ||
            (activeTab === 'promotion' &&
              tempSelectedNotification.length !== 4)) && (
            <button
              className="b1-btn"
              onClick={handleActivateNotification}
              disabled={
                (activeTab === 'referral' &&
                  tempSelectedNotification?.length === 2) ||
                (activeTab === 'promotion' &&
                  tempSelectedNotification?.length === 4) ||
                selectedNotification?.length === 0
              }
            >
              {tempSelectedNotification?.length > 0 ? 'Update' : 'Activate'}
              {/* && isNotificationEnabled */}
              {/* tempSelectedNotification.length === 0 || */}
            </button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default NotificationSetting;
